// extracted by mini-css-extract-plugin
module.exports = {"board":"Board_board__1ky3k","visibility":"Board_visibility__3li4J"};